import { T, Var } from 'gt-react';
import config from 'src/config';

export function CopyrightOverlay() {
  const year = new Date().getFullYear();
  return (
    <div className="fixed bottom-2 right-2 z-50 pointer-events-none select-none">
      <span className="text-xs text-muted-foreground/50 font-light">
        <T context="copyright footer notice with support email">
          Gently © <Var>{year}</Var> <Var>{config.supportEmail}</Var>
        </T>
      </span>
    </div>
  );
}
